// extracted by mini-css-extract-plugin
export default {"backToTop":"Layout_backToTop__kPJuQ","outColor":"Layout_outColor__DqRaS","slidbarStyle":"Layout_slidbarStyle__GjrOz","contentStyle":"Layout_contentStyle__A0T1H"};